import ChecklistCompleteChest from './ChecklistCompleteChest'

interface Props {
  chestAnimation: boolean
  handleAnimation: () => void
}

export default function ChestAnimation({ chestAnimation, handleAnimation }: Props): React.ReactElement {
  return (
    <div className="fixed inset-0 bg-gray-medium-dark bg-opacity-80 flex items-center justify-center z-modal-chest">
      <ChecklistCompleteChest chestAnimation={chestAnimation} closeAnimation={handleAnimation} />
    </div>
  )
}
